import React, { useContext, useState } from "react";
import Col from "../../../UIcomponent/Column";
import StyledButton from "../../../UIcomponent/Button";
import LocalContext from "../../../Context/LocalContetxt";
import "./DashboardTransactions.scss";
import { ThemeContext } from "styled-components";
import DashboradTitle from "../DashboradTitle/DashboradTitle";
import { Title } from "../../../UIcomponent/Title";
const DashboardTransactions = (props) => {
  const lang = useContext(LocalContext).lang;
  const theme = useContext(ThemeContext);
  const { IncomeStats } = props;

  const IncomeStatsList = [
    {
      name: "24 ساعت اخیر",
      value: "Daily",
    },
    {
      name: "هفت روز اخیر",
      value: "Weekly",
    },
    {
      name: "30 روز اخیر",
      value: "Monthly",
    },
    {
      name: "کل",
      value: "total",
    },
  ];
  const IncomeStatsSwitch = (i) => {
    switch (i) {
      case 0:
        return ((IncomeStats.DailyIncome || 0) / 10).toLocaleString(lang);
        break;
      case 1:
        return ((IncomeStats.WeeklyIncome || 0) / 10).toLocaleString(lang);
        break;
      case 2:
        return ((IncomeStats.MonthlyIncome || 0) / 10).toLocaleString(lang);
        break;
      case 3:
        return ((IncomeStats.AllIncome || 0) / 10).toLocaleString(lang);
        break;

      default:
        break;
    }
  };
  return (
    <Col
      xl={24}
      lg={24}
      md={24}
      sm={24}
      xs={24}
      className="l__DashboardTransactions"
    >
      <DashboradTitle title="گزارش درآمد" />
      <Col
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        className="c__DashboardTransactions"
      >
        {IncomeStats &&
          IncomeStatsList.map((stats, i) => {
            return (
              <Col
                xl={5.5}
                lg={5.5}
                md={5.5}
                sm={10.5}
                xs={11.5}
                className="o__DashboardTransactions"
              >
                <Col
                  className="o__DashboardTransactions__Title"
                  xl={18}
                  lg={18}
                  md={18}
                  sm={18}
                  xs={18}
                >
                  <Title>{stats.name}</Title>
                </Col>

                <Col
                  xl={18}
                  lg={18}
                  md={18}
                  sm={18}
                  xs={18}
                  className="o__DashboardTransactions__Value"
                >
                  {IncomeStats && IncomeStatsSwitch(i) + " " + "تومان"}
                </Col>
              </Col>
            );
          })}
      </Col>
    </Col>
  );
};

export default DashboardTransactions;
